import React from 'react';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const HomePageStories = () => {
    
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 4,
        variableWidth: true
    };

    return (
        <div className="static-border py-4 mb-4 px-4 storyArea">
            <Slider {...settings}>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://i.pinimg.com/236x/94/c8/b5/94c8b53941b80c2b1e7c753485c0eca3--gumball-xp.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://i.ytimg.com/vi/z_9mqGnAwNc/maxresdefault.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://i.pinimg.com/236x/94/c8/b5/94c8b53941b80c2b1e7c753485c0eca3--gumball-xp.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://cdn.vox-cdn.com/thumbor/BPDSBT6ZYv9k7rxI3KSFHRQGvCU=/0x1625:4050x5298/1200x675/filters:focal(1742x3008:2390x3656)/cdn.vox-cdn.com/uploads/chorus_image/image/69317099/ATDL_TA_Key_Art.0.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://i.pinimg.com/236x/94/c8/b5/94c8b53941b80c2b1e7c753485c0eca3--gumball-xp.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://cdn.vox-cdn.com/thumbor/EtP7U5LLQBShAkFIF0c24AnusAs=/0x0:620x349/1200x800/filters:focal(197x65:295x163)/cdn.vox-cdn.com/uploads/chorus_image/image/54841245/Regular_Show-_Mordecai___Rigby_in_8-Bit_Land_02.0.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://i.pinimg.com/236x/94/c8/b5/94c8b53941b80c2b1e7c753485c0eca3--gumball-xp.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://cdn.vox-cdn.com/thumbor/BPDSBT6ZYv9k7rxI3KSFHRQGvCU=/0x1625:4050x5298/1200x675/filters:focal(1742x3008:2390x3656)/cdn.vox-cdn.com/uploads/chorus_image/image/69317099/ATDL_TA_Key_Art.0.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://i.pinimg.com/236x/94/c8/b5/94c8b53941b80c2b1e7c753485c0eca3--gumball-xp.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://cdn.vox-cdn.com/thumbor/EtP7U5LLQBShAkFIF0c24AnusAs=/0x0:620x349/1200x800/filters:focal(197x65:295x163)/cdn.vox-cdn.com/uploads/chorus_image/image/54841245/Regular_Show-_Mordecai___Rigby_in_8-Bit_Land_02.0.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://i.pinimg.com/236x/94/c8/b5/94c8b53941b80c2b1e7c753485c0eca3--gumball-xp.jpg" />
                    </div>
                </div>
                <div className="storyItem" style={{ width:65 }}>
                    <div className="borderCustom">
                        <img className=" w-100 h-100 " src="https://cdn.vox-cdn.com/thumbor/BPDSBT6ZYv9k7rxI3KSFHRQGvCU=/0x1625:4050x5298/1200x675/filters:focal(1742x3008:2390x3656)/cdn.vox-cdn.com/uploads/chorus_image/image/69317099/ATDL_TA_Key_Art.0.jpg" />
                    </div>
                </div>
            </Slider>
        </div>
    );
}

export default HomePageStories;
